import { Spinner } from "components/Loading";
import {
  PuzzleImage,
  Table,
  SpoilerText,
} from "components/PuzzleContent/puzzle-components";
import { useAccessiblePuzzles } from "stores/ScopeStateStore";

const DATA = [
  ["1666cc83", "Furnace"],
  ["cc030a83", "Diorite"],
  ["5fe01d16", "Minecart"],
  ["f1926208", "Crafting Table"],
  ["f4c9b812", "Note Block"],
  ["a04a8900", "Dropper"],
  ["b12e98eb", "Iron Bars"],
  ["9b406a6b", "Piston"],
  ["75ebe34f", "Observer"],
  ["5adcb1ca", "Chest"],
  ["432a3d92", "Smithing Table"],
  ["f739d831", "Compass"],
] as const;

export function SurvivingTheOpenWorld({
  staticPuzDir,
  i,
}: {
  staticPuzDir: string;
  i: number;
}) {
  const puzzles = useAccessiblePuzzles();
  if (puzzles === null) return <Spinner />;

  if (i === 1) {
    return (
      <Table
        cells={DATA.map(([puzName]) => [
          puzzles[puzName].displayName,
          <SpoilerText key={puzName}>{puzzles[puzName].answer}</SpoilerText>,
        ])}
      />
    );
  }

  return (
    <Table
      headers={["Puzzle", "Recipe", "Item/Block", "Answer"]}
      cells={DATA.map(([puzName, item]) => {
        const puz = puzzles[puzName];

        return [
          puz.displayName,
          <PuzzleImage
            key={puzName}
            staticPuzDir={staticPuzDir}
            name={item.toLowerCase().replace(" ", "_")}
          />,
          item,
          <SpoilerText key={puzName}>{puz.answer}</SpoilerText>,
        ];
      })}
    />
  );
}
